module.exports = __webpack_public_path__ + "logo_heineken-e8a0419c15303f5a0f30ce5e6af7a3b0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logo_heineken.png
// module id = 1377
// module chunks = 1